import { useEffect, useContext } from 'react';

import { GeneralContext } from '../../../core/app-context/GeneralContext';
import Services from '../services';
import usePageStore from '../store/pageStore';

export default function useGetDashData() {
  const { setErrorMessage, store } = useContext(GeneralContext);
  const setLoadingDashConfigs = usePageStore(
    (state) => state.setLoadingDashConfigs,
  );
  const setDashData = usePageStore((state) => state.setDashData);

  useEffect(() => {
    const fetchConfigs = async () => {
      if (store) {
        setLoadingDashConfigs(true);
        const fetchedData = await Services.getDashData({
          storeId: store.id,
        });
        if (fetchedData) {
          setDashData(fetchedData);
        } else {
          setErrorMessage('Erro ao carregar dados do dashboard');
        }
        setLoadingDashConfigs(false);
      }
    };
    fetchConfigs();
  }, [store]);
}
